import { useCart } from "../context/CartContext";
import { useShipping } from "../context/ShippingContext";

const API_BASE = process.env.REACT_APP_API_URL || "";

interface CreateOrderResponse {
  orderId: number | string;
  orderKey: string;
  orderNumber?: string;
  total: string;
  paymentUrl?: string;
  discountTotal?: string;
}

export const useCreateOrder = () => {
  const { cart, couponCode, packageFeeTotal, packageOrderActive } = useCart();
  const { shipping, shippingMethod, deliverySelection } = useShipping();

  const orderBilling = { ...shipping };
  const { email, phone, ...orderShipping } = shipping;

  const createOrder = async (): Promise<CreateOrderResponse> => {
    const response = await fetch(`${API_BASE}/api/orders/create`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        cart,
        billing: orderBilling,
        shipping: orderShipping,
        shippingMethod,
        deliverySelection: deliverySelection || undefined,
        couponCode: packageOrderActive ? undefined : couponCode,
        packageFeeTotal,
        packageOrder: packageOrderActive,
      }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error?.error || "Failed to create order");
    }

    return response.json();
  };

  return { createOrder };
};
